import React, {type FC, useMemo} from 'react';

import {isMountedInShell} from '../../../../shellRemote';
import * as urls from '../../../../util/urls';
import {removeNullUndefinedOrFalse} from '../../../../util/utility';
import Breadcrumbs, {type BreadcrumbPart} from '../../../Breadcrumbs';

export type NavBreadcrumbsRegistriesProps = {
  orgName: string;
  registryName?: string;
};

export function useNavBreadcrumbsRegistriesParts({
  orgName,
  registryName,
}: NavBreadcrumbsRegistriesProps): BreadcrumbPart[] {
  const parts: BreadcrumbPart[] = useMemo(
    () =>
      removeNullUndefinedOrFalse([
        !isMountedInShell() && {
          label: 'Registry',
          to: urls.globalRegistry(orgName),
        },
        registryName != null && {
          label: registryName,
          to: urls.globalRegistry(orgName, registryName),
        },
      ]),
    [orgName, registryName]
  );

  return parts;
}

export const NavBreadcrumbsRegistries: FC<
  NavBreadcrumbsRegistriesProps
> = params => {
  const parts = useNavBreadcrumbsRegistriesParts(params);
  return <Breadcrumbs parts={parts} />;
};
